import {
    faArrowLeft,
    faPersonToDoor,
    faScissors,
    faUser,
    type IconDefinition,
} from "@fortawesome/pro-regular-svg-icons";

export const regularIcons: IconDefinition[] = [
    faArrowLeft,
    faPersonToDoor,
    faScissors,
    faUser,
];
